import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const IndividualSpecSection = (props) => {
  const { specNameEs, specNameEn, descNameEs, descNameEn, lenguage } = props;
  return (
    <FlexContainer className={'flex-column gap-10 width100'}>
      <Label className={'text-20 width100 margt20 m-margt10 text-justify'}>
        <strong>{lenguage === 'EN' ? specNameEn : specNameEs}</strong>
      </Label>
      {lenguage === 'EN' && (
        <Label type="text-14" className={'width100 margtb10 m-margtb0 text-justify'}>
          {descNameEn}
        </Label>
      )}
      {lenguage === 'ES' && (
        <Label type="text-14" className={'width100 margtb10 m-margtb0 text-justify'}>
          {descNameEs}
        </Label>
      )}
    </FlexContainer>
  );
};

export const SpecsSection = (props) => {
  const { lenguage, spaceData } = props;
  const translations = {
    'Sala de Juntas': 'Meeting Room',
    Terrazas: 'Terrace',
    Coworking: 'Coworking',
  };
 
  const translatedTitle = translations[spaceData?.subtype_title] || spaceData?.subtype_title;
  return (
    <FlexContainer className={'m-flex-column gap-20'}>
      <IndividualSpecSection
        lenguage={lenguage}
        specNameEs={'Tipo de Espacio'}
        specNameEn={'Space Type'}
        descNameEs={spaceData?.subtype_title}
        descNameEn={translatedTitle}
      />
      <IndividualSpecSection
        lenguage={lenguage}
        specNameEs={'Capacidad Max'}
        specNameEn={'Max Capacity'}
        descNameEs={'Hasta ' + spaceData?.host_capacity + ' personas'}
        descNameEn={'Up to ' + spaceData?.host_capacity + ' people'}
      />
      <IndividualSpecSection
        lenguage={lenguage}
        specNameEs={'Horario'}
        specNameEn={'Schedule'}
        descNameEs={'09 a 20 horas'}
        descNameEn={'9 a.m. to 8 p.m'}
      />
      <IndividualSpecSection
        lenguage={lenguage}
        specNameEs={'Precio'}
        specNameEn={'Price'}
        descNameEs={spaceData?.formattedPrice}
        descNameEn={spaceData?.formattedPrice}
      />
    </FlexContainer>
  );
};
